import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';
import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import audioInstructions from '../../LNConstants';
import {
    activateNextButton, blockScreen, unblockScreen, greyOutScreen,
} from '../../../common/screen/screenActions';
import { highlightPossibleResponse, resetSelectedIndex } from '../../../common/questions/questionsActions';
import selectors from '../../../rootSelectors';

export const narratePracticeScreen = ({ audio }) => async (dispatch, getState) => {
    const state = getState();
    const correctResponse = selectors.getLNPracticeCorrectResponse(state);

    dispatch(setAvatarInstructions(audioInstructions.practiceInstructionStart));
    await dispatch(playAvatarAudio(audioInstructions.practiceInstructionStart));
    await dispatch(playStimulusAudio([audio], GENERAL_AUDIO_DELAY));
    dispatch(highlightPossibleResponse(correctResponse));
    await dispatch(playAvatarAudio(audioInstructions.practiceInstructionActive));
    dispatch(resetSelectedIndex());
};

export const narrateScreenResponseClick = () => async (dispatch) => {
    dispatch(blockScreen());
    dispatch(greyOutScreen());
    dispatch(setAvatarInstructions(audioInstructions.practiceInstructionReady));
    await dispatch(playAvatarAudio(audioInstructions.practiceInstructionReady));
    dispatch(activateNextButton());
    dispatch(unblockScreen());
};
